var _ellipse, _ellipse2, _ellipse3, _ellipse4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88.5 76.8"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-44.806 68.084 20.31)",
    cx: 68.1,
    cy: 20.3,
    rx: 24.7,
    ry: 14.8,
    fill: "#1f80ff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-45.211 62.497 62.126)",
    cx: 62.5,
    cy: 62.1,
    rx: 11.1,
    ry: 17.7,
    fill: "#4aa147"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-45.195 20.38 20.3)",
    cx: 20.4,
    cy: 20.3,
    rx: 14.8,
    ry: 24.7,
    fill: "#cf2c91"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-44.789 25.98 62.08)",
    cx: 26,
    cy: 62.1,
    rx: 17.7,
    ry: 11.1,
    fill: "#f58220"
  })));
}
export default SvgLogo;